import { render, staticRenderFns } from "./GlobalvalueRecord.vue?vue&type=template&id=53a38caa&scoped=true&"
import script from "./GlobalvalueRecord.vue?vue&type=script&lang=js&"
export * from "./GlobalvalueRecord.vue?vue&type=script&lang=js&"
import style0 from "./GlobalvalueRecord.vue?vue&type=style&index=0&id=53a38caa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a38caa",
  null
  
)

export default component.exports